import { isEmpty } from "lodash";
import { Routes, Route, Navigate } from "react-router-dom";

import { decodeJWT } from "../../utils";

import LogOut from "../../components/Auth/LogOut/LogOut";

import AuthContext from "../../context/AuthContext/AuthContext";
import MainAuthPage from "../../components/Auth/MainAuthPage/MainAuthPage";

const AuthContainer = () => {
  const token = localStorage.getItem("token");

  const isLogin = !isEmpty(token);

  const decodedToken = decodeJWT(token);

  const redirectUrl = `/${
    decodedToken?.usertype === "ADMIN" ? "Public/Home" : "Public/Home"
  }`;

  return (
    <>
      <AuthContext>
        <Routes>
          {/* Sign In & Sign Up & Forget Password */}
          <Route
            path="/"
            element={isLogin ? <Navigate to={redirectUrl} /> : <MainAuthPage />}
          />
          {/* Log Out */}
          <Route path="/Log-Out" element={<LogOut />} />
        </Routes>
      </AuthContext>
    </>
  );
};

export default AuthContainer;
